import { Center, Spinner } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useGetRegistration } from '../../../services/hooks/Registration/useGetRegistration';
import { useRequestDetailSelectiveProcess } from '../../../services/hooks/SelectiveProcess/useRequestDetailSelectiveProcess';
import SelectiveProcessSubscribe from './Index';
import SubscriptonAndExemption from '../Exemptions/Forms/FormExemption/SubscriptonAndExemption';
import OnlyExemption from '../Exemptions/Forms/FormExemption/OnlyExemption';

const EditRegistrationRoute: React.FC = () => {
  const { selectiveProcessId = '', registrationId = '' } = useParams();
  const process = useRequestDetailSelectiveProcess(selectiveProcessId);
  const registration = useGetRegistration(registrationId);

  if (process.isLoading || registration.isLoading) {
    return <Center minH="50vh"><Spinner /></Center>;
  }

  const exemptionIsOpen = process.data?.general_info.open_exemption && Boolean(registration.data?.analysis_exemption);
  const creationType = process.data?.general_info.exemption_registration_creation_type;

  if (exemptionIsOpen && creationType === 'unified') return <SubscriptonAndExemption />;
  if (exemptionIsOpen && creationType === 'standby') return <OnlyExemption />;
  return <SelectiveProcessSubscribe />;
};

export default EditRegistrationRoute;
